import { api } from './api';

export const usersApi = api.injectEndpoints({
  endpoints: (build) => ({
    getUsers: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "users",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.records.map(({ model}) => ({ type: 'Users', id: model.ID })),
            { type: 'Users', id: 'LIST' },
          ]
          :
          [{ type: 'Users', id: 'LIST' }]

      }
    }),
    getMyUsers: build.query({
      query: (
        query = {
          skip:0,
          limit: 40,
          filter: {text: ''},
        },
      ) => ({
        url: "myusers",
        method: "POST",
        body: JSON.stringify(query)
      }) ,
      providesTags: (result) => {
        return result.data ?
          [ ...result.data.records.map(({ model}) => ({ type: 'MyUsers', id: model.ID })),
            { type: 'MyUsers', id: 'LIST' },
          ]
          :
          [{ type: 'MyUsers', id: 'LIST' }]

      }
    }),
  })
});


export const {
  useGetUsersQuery,
  useGetMyUsersQuery,
} = usersApi;
